import { render, staticRenderFns } from "./ContactSupport.vue?vue&type=template&id=1c674a4e&scoped=true"
import script from "./ContactSupport.vue?vue&type=script&lang=js"
export * from "./ContactSupport.vue?vue&type=script&lang=js"
import style0 from "./ContactSupport.vue?vue&type=style&index=0&id=1c674a4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c674a4e",
  null
  
)

export default component.exports